module.exports = __webpack_public_path__ + "img/type_right_6.167514cd.png";